import CalendarIndex from './CalendarIndex'

export default {
  CalendarIndex
}
